import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { connect, disconnect } from '../../actions/wallet';
import { Spinner, Alert, BlockchainService } from '../../services';

const useWalletProvider = (enableNetworkCheck = false) => {
  const dispatch = useDispatch();
  const networkCheckInterval = useRef();
  const { user: authUser } = useSelector((state) => state.auth);
  const { walletConnected: isWalletConnected, wallet: authWallet } =
    useSelector((state) => state.wallet);

  const defaultWalletValues = {
    address: null,
    balance: null,
  };
  const defaulNetworkValues = {
    name: null,
    chainId: null,
  };
  const [wallet, setWallet] = useState(defaultWalletValues);
  const [network, setNetwork] = useState(defaulNetworkValues);

  useEffect(() => {
    if (enableNetworkCheck) {
      (() => {
        networkCheckInterval.current = setInterval(networkDetails, 5000);
      })();
    } else {
      isWalletConnected && networkDetails();
    }
    listenToMetamaskEvents();

    return () => {
      if (enableNetworkCheck) clearInterval(networkCheckInterval.current);
      setWallet(null);
      setNetwork(null);
    };
  }, []);

  const connectWallet = async () => {
    Spinner.show();
    try {
      let walletResp = await BlockchainService.connectWallet();

      if (walletResp.status === 'failure') {
        Spinner.hide();
        Alert.error(walletResp.message);
        return false;
      }
      let formData = {
        walletAddress: walletResp.data.walletAddress,
      };

      // return false;
      // setShowModal(false);
      setWallet({
        ...wallet,
        address: walletResp.data.walletAddress,
        balance: walletResp.data.balance,
      });
      dispatch(connect(formData));
      Spinner.hide();
      listenToMetamaskEvents();
      // getWalletDetails();
    } catch (error) {
      Spinner.hide();
      Alert.error(error.message);
    }
  };
  const networkDetails = async () => {
    try {
      let response = await BlockchainService.networkDetails();
      if (response.status === 'failure') {
        let _error = response.data;
        if (_error != null && _error?.code === 'NETWORK_ERROR') {
          return false;
        } else if (_error != null && _error?.code === 'PROVIDER_UNAVAILABLE') {
          return false;
        } else {
          Alert.error(response.message);
          Spinner.hide();
          return false;
        }
      }

      setNetwork({
        name: response.data.name,
        chainId: response.data.chainId,
      });
    } catch (error) {
      Spinner.hide();
      Alert.error(error.message);
    }
  };

  const disconnectWallet = async () => {
    await Promise.resolve(dispatch(disconnect()));
  };

  const listenToMetamaskEvents = () => {
    try {
      let metamaskResp = BlockchainService.isMetaMaskInstalled();

      if (metamaskResp.status === 'success') {
        metamaskResp.data.on('accountsChanged', function (account) {
          if (account != null && account.length > 0) {
            if (authUser == null || authUser.userId == null) {
              disconnectWallet();
            }

            if (authWallet && authWallet.walletAddress !== undefined) {
              if (authWallet && authWallet.walletAddress !== account[0]) {
                disconnectWallet();
                connectWallet();
              }
            }
          } else {
            disconnectWallet();
          }
        });

        metamaskResp.data.on('chainChanged', function (chainId) {
          setNetwork({
            ...network,
            chainId: chainId,
          });
        });
      }
      // }
    } catch (error) {
      Alert.error(error.message);
    }
  };

  return {
    wallet,
    network,
    connectWallet,
    disconnectWallet,
    isWalletConnected,
    authWallet,
  };
};
export default useWalletProvider;
